import { getApiError } from "../../../../../../../../../../../../../../../../../api/error-handling"

const MESSAGES: Record<string, string> = {
  letter_signature_photo_too_large: "Das Foto ist zu groß. Maximal erlaubt sind 12 MB.",
  letter_signature_photo_unsupported_type:
    "Bitte wählen Sie ein JPEG-, PNG-, WebP-, HEIC- oder HEIF-Foto aus.",
  letter_signature_photo_unreadable:
    "Das Foto konnte nicht gelesen werden. Bitte nehmen Sie ein neues Foto auf.",
  letter_signature_photo_no_ink:
    "Auf dem Foto wurde keine ausreichend deutliche Unterschrift erkannt.",
  letter_signature_photo_low_contrast:
    "Die Unterschrift hebt sich nicht ausreichend vom Papier ab. Bitte verwenden Sie einen dunklen Stift und gutes Licht.",
}

export const signaturePhotoUploadErrorMessage = (error: unknown): string => {
  const apiError = getApiError(
    error,
    "Die Unterschrift konnte nicht aus dem Foto übernommen werden.",
  )

  return (apiError.reasonCode && MESSAGES[apiError.reasonCode]) || apiError.message
}
